import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateBoardObjectV3 = OpalApi<'UpdateBoardObjectV3', 200>

export const updateBoardObject: UpdateBoardObjectV3 = async (args = {}) => {
  const boardObjectId = args.params?.path.board_object_id

  if (typeof boardObjectId !== 'string') {
    throw new Error('Must supply a valid board_object_id.')
  }

  const url = new URL(
    `/board_objects/v3/${boardObjectId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
